import { cn } from '@kalos/ui';
import { type ReactNode } from 'react';

export type StatusPillTone = 'muted' | 'info' | 'success' | 'warning';

const toneClass: Record<StatusPillTone, string> = {
  muted: 'bg-muted text-muted-foreground',
  info: 'bg-info text-info-foreground',
  success: 'bg-success text-success-foreground',
  warning: 'bg-warning text-warning-foreground',
};

/**
 * A short status or flag on a phone record, as a token tint pair. `muted` for a plain state,
 * `info` for work in motion, `success` for done or accepted, `warning` for an overrun or something
 * missing. Nothing here is red: red is for danger, and none of these are.
 */
export const StatusPill = ({
  tone = 'muted',
  children,
  className,
}: {
  tone?: StatusPillTone;
  children: ReactNode;
  className?: string;
}) => (
  <span
    className={cn(
      'inline-flex w-fit shrink-0 items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium tabular-nums',
      toneClass[tone],
      className,
    )}
  >
    {children}
  </span>
);
